/**
 * Time conversion constants
 * Used for date/time calculations and conversions
 */

export const millisecondsPerSecond = 1000;
export const secondsPerMinute = 60;
export const minutesPerHour = 60;
export const hoursPerDay = 24;
export const daysPerWeek = 7;
export const daysPerYear = 365;

export const millisecondsPerMinute = millisecondsPerSecond * secondsPerMinute; // 60000
export const millisecondsPerHour = millisecondsPerMinute * minutesPerHour; // 3600000
export const millisecondsPerDay = millisecondsPerHour * hoursPerDay; // 86400000
export const millisecondsPerWeek = millisecondsPerDay * daysPerWeek; // 604800000

export const secondsPerHour = secondsPerMinute * minutesPerHour; // 3600
export const secondsPerDay = secondsPerHour * hoursPerDay; // 86400
export const secondsPerWeek = secondsPerDay * daysPerWeek; // 604800

export const minutesPerDay = minutesPerHour * hoursPerDay; // 1440
export const minutesPerWeek = minutesPerDay * daysPerWeek; // 10080

export const hoursPerWeek = hoursPerDay * daysPerWeek; // 168
